import { FacilityMedicalInstitutionType } from '../entites/FacilityInfo'

export const getMedicalInstitutionTypeLabel = (
  type: FacilityMedicalInstitutionType,
): string => {
  if (type === 'any_medical_institution') return 'どこの医療機関でもよい'
  else if (type === 'specified_medical_institution') return '指定医療機関のみ'
  return ''
}
